import { render } from "./Test.vue?vue&type=template&id=e50d0a60"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=e50d0a60&lang=less"
script.render = render

export default script